export default __webpack_public_path__ + "static/media/backgrid.7f89c5e6.png";